import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { HikariState } from '@/store/Hikari/state';

// tslint:disable-next-line:no-var-requires
const _ = require('lodash');

import { HikariConfig } from '@/data/hikariConfig';

import feeConfig from '@/../config/common.json';

const getters: GetterTree<HikariState, RootState> = {
  router: (state: HikariState): string => {
    return state.router;
  },
  phoneOptions: (state: HikariState): string[] => {
    return state.phoneOptions;
  },
  phonePlan: (state: HikariState): string => {
    return state.phonePlan;
  },
  building: (state: HikariState): string => {
    return state.building;
  },
  entryType: (state: HikariState): string => {
    return state.entryType;
  },
  currentUsageType: (state: HikariState): string => {
    return state.currentUsageType;
  },
  applyType: (state: HikariState): string => {
    return state.applyType;
  },
  staticIp: (state: HikariState): string => {
    return state.staticIp;
  },
  initialTotalAmount: (state: HikariState) => (
    hikariConfig: HikariConfig
  ): number => {
    let total = 0;

    // 光回線料金
    const c = hikariConfig.findCourse(state.entryType, state.building, state.currentUsageType, state.applyType);
    total += c ? c.initialCharge() : 0;

    // 光でんわ
    const d = hikariConfig.findPhone(state.phonePlan);
    // 条件に応じてかかる初期費用を計算
    total += d ? d.initialCharge(state.entryType) : 0;

    // 光固定IP
    if (state.applyType === '1g') {
      const s = hikariConfig.findStaticIp(state.staticIp);
      total += s ? s.initialCharge : 0;
    }

    return total;
  },
  totalAmountOfMonth: (state: HikariState) => (hikariConfig: HikariConfig) => {
    let total = 0;

    // 光回線料金
    const c = hikariConfig.findCourse(state.entryType, state.building, state.currentUsageType, state.applyType);
    total += c ? c.monthlyCharge() : 0;

    // ルータのレンタル料金
    const router = hikariConfig.findRouter(state.router);
    total += router ? router.monthlyCharge() : 0;

    // 光でんわ
    const d = hikariConfig.findPhone(state.phonePlan);
    total += d ? d.monthlyCharge : 0;
    // でんわオプション
    _.each(state.phoneOptions, (optionId: string) => {
      if (d) {
        total += d.optionMonthlyCharge(optionId);
      }
    });

    // スタート割
    if (c && state.applyType === '10g') {
      const phoneSetCampaign = hikariConfig.findPhoneCampaign('スタート割');
      total += phoneSetCampaign ? phoneSetCampaign.料金 : 0;
    }

    // 光電話アリの場合
    if (state.router != '' && state.phonePlan && (state.phonePlan === 'basic' || state.phonePlan === 'ace')) {
      const phoneSetCampaign = hikariConfig.findPhoneCampaign('光電話セット割');
      total += phoneSetCampaign ? phoneSetCampaign.料金 : 0;
    }

    // ユニバーサルサービス料および電話リレーサービス料
    if (state.phonePlan && state.phonePlan !== 'none') {
      const fee = feeConfig.fee.universal_and_relay_service.charge;
      total += fee;
      total += state.phoneOptions.includes('extra_number') ? fee : 0;
    }

    // 光固定IP
    if (state.applyType === '1g') {
      const s = hikariConfig.findStaticIp(state.staticIp);
      total += s ? s.monthlyCharge : 0;
    }

    return total;
  },
};

export default getters;
